<template>
  <div>
    <template v-if="item.children.length === 0">
      <b-menu-item
        :active="item.id === isRoute"
        @click="changeActive(item.id, item.name), setRoute(item.id)"
      >
        <template #label>
          <div class="is-flex is-align-items-center">
            <b-icon
              v-if="item.icon !== null"
              pack="fas"
              :icon="item.icon"
              class="mr-2"
            />
            {{ item.name }}
          </div>
        </template>
      </b-menu-item>
    </template>
    <template v-else>
      <b-menu-item
        @click="changeActive(item.id, item.name), setRoute(item.id)"
        :active="childIsActive(isActive, item)"
        :expanded="childIsActive(isActive, item)"
      >
        <template #label="props">
          <div class="is-flex is-align-items-center">
            <b-icon
              v-if="item.icon !== null"
              pack="fas"
              :icon="item.icon"
              class="mr-2"
            />
            {{ item.name }}
            <div class="is-flex-grow-1"></div>
            <b-icon
              class="is-pulled-right"
              pack="fas"
              :icon="props.expanded ? 'caret-up' : 'caret-down'"
            />
          </div>
        </template>
        <template v-for="element in item.children">
          <MenuItem
            :item="element"
            :key="element.id"
            :isActive="isActive"
            :isRoute="isRoute"
            :product="product"
            @changeActive="changeActive"
            @setRoute="setRoute"
          />
        </template>
      </b-menu-item>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
export default {
  name: 'MenuItem',
  props: {
    item: {
      required: true,
      type: Object,
      default: null,
    },
    product: {
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      navFlatById: 'product/navFlat/dataById',
      isActive: 'menu/isActive',
      isRoute: 'menu/isRoute',
    }),
  },
  methods: {
    ...mapMutations({
      setActive: 'menu/SET_ACTIVE',
      setRoute: 'menu/SET_ROUTE',
    }),
    childIsActive(isActive, item) {
      if (isActive === item.id) {
        return true;
      }
      for (let i = 0; i < item.children.length; i += 1) {
        if (this.childIsActive(isActive, item.children[i])) {
          return true;
        }
      }
      return false;
    },
    changeActive(itemId, itemName) {
      if (this.isRoute !== undefined && this.isRoute === itemId) return; // keep router from redirecting to same page and throwing an exceptipn
      if (this.navFlatById(itemId).link !== null && itemName) {
        this.$router.push({
          name: 'View',
          params: {
            productId: this.product.id,
            routeId: itemId,
            productName: this.convertRouteName(this.product.name),
            routeName: this.convertRouteName(itemName),
          },
        });
      }
      this.setActive(itemId);
    },
    convertRouteName(plain) {
      if (!plain) return plain;
      return plain
        .replace(/\s/g, '-')
        .replace(/[^\w-]/g, '')
        .replace(/-+/g, '-');
    },
  },
};
</script>
